// Put your applicaiton javascript here

$(document).ready(function () {
	$('#mob-nav-menu').click(function(){
		$('#mob-menu').toggleClass("active");
	});

	$('#footer .parentlink').click(function(){
		$('#footer .parentlink, #footer #desktop-menu, #footer .hidden-div').toggleClass("active");
	});

	$('.parentlink').click(function(){
		$('.parentlink span, .childlink').toggleClass("active");
	});
});